import { AfterViewChecked, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NormalizedTextBox } from '../../../../../shared/text-focus.service';

/** Renders exact, multi-box text matches in the same canvas coordinate space as Preview. */
@Component({
  selector: 'app-text-highlight-overlay',
  imports: [],
  templateUrl: './text-highlight-overlay.component.html',
  styleUrls: ['./text-highlight-overlay.component.scss'],
})
export class TextHighlightOverlayComponent implements AfterViewChecked {
  @ViewChild('highlightSvg') private highlightSvg?: ElementRef<SVGSVGElement>;
  @Input() boxes: NormalizedTextBox[] = [];
  @Input() normalized = false;
  @Input() canvasWidth = 0;
  @Input() canvasHeight = 0;
  @Input() canvasScale = 1;
  @Input() canvasOffsetX = 0;
  @Input() canvasOffsetY = 0;

  private gestureTransform = '';
  private gestureTransformOrigin = '';
  private gestureTransition = '';
  private gestureTargetEl: SVGSVGElement | null = null;

  ngAfterViewChecked(): void {
    const currentSvg = this.highlightSvg?.nativeElement ?? null;
    if (currentSvg !== this.gestureTargetEl) {
      this.applyGestureTransform();
    }
  }

  displayBox(box: NormalizedTextBox): NormalizedTextBox {
    const sourceWidth = this.normalized ? this.canvasWidth : this.canvasScale;
    const sourceHeight = this.normalized ? this.canvasHeight : this.canvasScale;
    return {
      x: box.x * sourceWidth,
      y: box.y * sourceHeight,
      width: box.width * sourceWidth,
      height: box.height * sourceHeight,
      rotationDegrees: box.rotationDegrees,
    };
  }

  rotation(box: NormalizedTextBox): string | null {
    return box.rotationDegrees ? `rotate(${box.rotationDegrees} ${box.x} ${box.y})` : null;
  }

  setGestureTransform(transform: string, transformOrigin: string, transition: string): void {
    this.gestureTransform = transform;
    this.gestureTransformOrigin = transformOrigin;
    this.gestureTransition = transition;
    this.applyGestureTransform();
  }

  private applyGestureTransform(): void {
    const svg = this.highlightSvg?.nativeElement;
    if (!svg) {
      this.gestureTargetEl = null;
      return;
    }
    svg.style.transition = this.gestureTransition;
    svg.style.transformOrigin = this.gestureTransformOrigin;
    svg.style.transform = this.gestureTransform;
    this.gestureTargetEl = svg;
  }
}
